import makeApiCall, {
  makePublicApiCall,
  makeUnauthenticatedApiCall,
} from "./axiosIndex";

const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Quotation",
      moduleFileType: "signature.png",
    },
  ],
};

const quotationApis = {
  quotationsCreationMethod: (data: any) =>
    makeApiCall({
      url: "/quotation-buyer/new",
      method: "post",
      data,
    }),
  newVersion: (data: any) =>
    makeApiCall({
      url: "/quotation-buyer/newVersion",
      method: "post",
      data,
    }),
  fetchList: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/list`,
    }),
  getById: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/getById`,
      params: { quotationId },
    }),
  fetchCounts: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/getCounts`,
    }),
  fetchPendingApprovals: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/pendingApprovals`,
    }),
    
  approve: (quotationId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      quotationId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/quotation-buyer/approve`,
      data: formData,
    });
  },

  reject: (
    quotationId: number,
    reason: string,
    files: File[] = []
  ): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      quotationId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/quotation-buyer/reject`,
      data: formData,
    });
  },

  Summary: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/funnel`,
      params: { quotationId },
    }),
  versionGraph: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/versionGraph`,
      params: { quotationId },
    }),
  approvalDetilsEventChain: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/approvalsByQuotationId`,
      params: { quotationId },
    }),
  quoteComparision: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/quoteComparision`,
      params: { quotationId },
    }),
  addScenarioBuilder: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/quotation-buyer/addScenarioBuilder`,
      data,
    }),
  getScenarioBuilder: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/getScenarioBuilder`,
      params: { quotationId },
    }),
  dynamicRankings: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/dynamicRankings`,
      params: { quotationId },
    }),
  shortListSuppliers: (quotationId: any, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/quotation-seller/shortListSuppliers`,
      params: { quotationId },
      data,
    }),
  getShortListed: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/getShortListed`,
      params: { quotationId },
    }),
  sendToQCApproval: (data: any, quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/quotation-seller/sendToQCApproval`,
      params: { quotationId },
      data,
    }),
  getQCList: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/getQCList`,
    }),
  getByQCId: (qcId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/getByQCId`,
      params: { qcId },
    }),
  qcApprove: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/quotation-seller/approveQC`,
      data,
    }),
  qcReject: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/quotation-seller/rejectQC`,
      data,
    }),
  editShortListed: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/quotation-seller/editShortListed`,
      data,
    }),
  removeShortListed: (quotationId: any, id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/quotation-seller/removeShortListed`,
      params: { quotationId, id },
    }),
  getQCApprovedList: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/getQCApprovedList`,
    }),
  getQCApprovedById: (qcId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/getQCApprovedById`,
      params: { qcId },
    }),
  addTargetPrice: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/quotation-buyer/addTargetPrice`,
      data,
    }),
  quotationTimeLine: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/quotationTimeLine`,
      params: { quotationId },
    }),
  latestByQuotationId: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/latestByQuotationId`,
      params: { quotationId },
    }),
  submitSupplierQuote: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-seller/quote",
      method: "post",
      data: data,
    }),
  fetchShortListBySupplierId: (
    quotationId: any,
    supplierId: any
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/fetchShortListBySupplierId`,
      params: { quotationId, supplierId },
    }),
  quotationDashboardCounts: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-buyer/quotationDashboardCounts",
      method: "post",
      data: data,
    }),
  latestBySupplierQuotationId: (
    quotationId: any,
    supplierId: any,
    isNewSupplier: any
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/latestBySupplierQuotationId`,
      params: { quotationId, supplierId, isNewSupplier },
    }),
  quotationSummary: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-dashboard/quotationSummary",
      method: "post",
      data: data,
    }),
  quotationMaterialWiseSavings: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-dashboard/quotationMaterialWiseSavings",
      method: "post",
      data: data,
    }),
  quotationResponseTime: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-dashboard/quotationResponseTime",
      method: "post",
      data: data,
    }),
  quotationTop10NegotiationByMaterials: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-dashboard/quotationTop10NegotiationByMaterials",
      method: "post",
      data: data,
    }),
  quotationMonthOnMonthSavings: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-dashboard/quotationMonthOnMonthSavings",
      method: "post",
      data: data,
    }),
  convertToPO: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-seller/convertToPO",
      method: "post",
      data: data,
    }),
  viewAllQCs: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/viewAllQCs`,
    }),
  getLinesByQCId: (qcId: any, quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/getLinesByQCId`,
      params: { qcId, quotationId },
    }),
  getNotRespondedSuppliers: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/unpublishedSuppliers`,
      params: { quotationId },
    }),
  selfQuote: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-seller/selfQuote",
      method: "post",
      data: data,
    }),
  emailNotify: (quotationId: any, data: any): Promise<any> =>
    makeApiCall<any>({
      url: `/quotation-buyer/emailNotify/${quotationId}`,
      method: "post",
      data,
    }),
  getLatestBySupplierQuotationId: (
    quotationId: any,
    supplierId: any
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/latestBySupplierQuotationId`,
      params: { quotationId, supplierId },
    }),
  qcExcelExport: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `quotation-seller/quoteComparisonExcelExport`,
      params: { quotationId },
    }),
  quoteNewVersion: (data: any) =>
    makeApiCall({
      url: "/quotation-seller/selfQuoteNewVersion",
      method: "post",
      data,
    }),
  fetchQuotedQuotationId: (supplierQuoteId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-seller/fetchQuotedQuotationId`,
      params: { supplierQuoteId },
    }),
  fetchRFQPaginationList: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-buyer/paginationList",
      method: "get",
      params,
    }),
  fetchRFQPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-buyer/paginationPendingApprovals",
      method: "get",
      params,
    }),
  fetchQCPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-seller/qcPaginationList",
      method: "get",
      params,
    }),
  fetchQCApprovalsPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-seller/qcPendingPaginationList",
      method: "get",
      params,
    }),
  fetchReadyToRewardPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/quotation-seller/qcApprovedPaginationList",
      method: "get",
      params,
    }),
  fetchStatusFilterOptions: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/status`,
    }),
  fetchOrderVersions: (id: string): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/quotation-buyer/versions?rfqId=${id}`,
    }),
  fetchPurchaseHistoryData: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/quotation-seller/fetchLatestMaterialPricesList`,
      data,
    }),
  materialBulkUploadCreate: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/quotation-buyer/materialBulkUploadCreate",
      data,
    }),
  rfqPriceBulkUpload: (data: any): Promise<any> =>
    makePublicApiCall<any>({
      url: "/quotation-seller/rfqPriceBulkUpload",
      method: "post",
      data: data,
    }),
  qcApproveMultipleLines: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/quotation-seller/approveMultiLineQC`,
      data,
    }),
  qcRejectMultipleLines: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/quotation-seller/rejectMultiLineQC`,
      data,
    }),
  createSupplierAccount: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/createPublicSupplier`,
      data,
    }),
  generateRfqPublicLink: (quotationId: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/quotation-buyer/generateRfqPublicLink/${quotationId}`,
    }),
  sendOtp: (mobileNumber: string, email: string, orgType: string = "Seller"): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/auth/validateUserAndSendOtp`,
      data: { mobileNumber, email, orgType },
    }),
  verifyOtp: (mobileNumber: string, otp: string): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/auth/verifyPublicLinkOtp`,
      data: { mobileNumber, otp },
    }),
  // Public quotation APIs (use public-token cookie)
  publicLinkQuote: (data: any): Promise<any> =>
    makePublicApiCall<any>({
      method: "post",
      url: "/quotation-seller/publicLinkQuote",
      data,
    }),
  fetchPublicLinkQuotationResponse: (quotationId: number): Promise<any> =>
    makePublicApiCall<any>({
      method: "get",
      url: `/quotation-seller/fetchPublicLinkQuotationResponse`,
      params: { quotationId },
    }),
  publicGetByLinkId: (linkId: string): Promise<any> =>
    makeUnauthenticatedApiCall<any>({
      method: "get",
      url: `/quotation-buyer/public-link/${linkId}`,
    }),
  captureSealedBid: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/quotation-buyer/captureSealedBid`,
      data,
    }),
};

export default quotationApis;
